import { DiContainerInjectFn } from '@/di/ts';
import { NotificationsService } from '@/notifications/services/notifications.service';

export default ((container) => {
  container
    .bind(NotificationsService)
    .to(NotificationsService)
    .inSingletonScope();
}) as DiContainerInjectFn;
